<template v-if="isEnableChatSound">
    <transition name="fade-info">
        <MiniChat 
            v-if="isMiniChatActive"
            @close-mini-chat="$emit('close-mini-chat-wrap')"
            @mute-users="muteUsersFun"
            @change-user="isActiveConversiation = false"
            :usersListAll="usersListAll"
            :isActiveConversiationProp="isActiveConversiation"
            :unreadCountProp="count"
            :miniChat="true" />
    </transition>
</template>
<script>
import { SimpleSound } from '/webpack-assets/vue/utils/simpleSound.js';
import MiniChat from '/webpack-assets/vue/templates/chat/chat.vue';
import { io } from "socket.io-client";
import axios from '/webpack-assets/vue/config/axios-config';
import { chatFetch } from '/webpack-assets/vue/templates/chat/parts/chatTokenManager';

  export default {
    name: 'MiniChatWrap',
    components: {
        MiniChat,
    },
    data() {
        return {
            isEnableChatSound:
            typeof window.settings?.enable_mini_chat === 'boolean'
                ? window.settings.enable_mini_chat
                : true,
            isActiveConversiation: false,
            isResponseDone: false,
            userIdChat: null,
            userMy: window?.common.user,
            isMuteChat: window.header?.chat?.is_mute,
            count: window.header?.chat?.count_unread_conversations || 0,
            user: window?.common.user,
            chat: window.header?.chat,
            language: window.common.language.code2 || 'en',
            countConversiation: 0,
            usersListAll: [],
            testUrlQuickChat: window.header?.chat?.api_host,
            chatSound: null,
        };
    },
    props: {
        mobile: {
            type: Boolean,
            required: false
        },
        isMiniChatActive: {
            type: Boolean,
            required: false
        }
    },
    mounted() {
      this.initSocket();
      
      if (this.isEnableChatSound) {
        this.getConversationsCount();
      }
      this.chatSound = new SimpleSound({
            src: ['/sounds/sound_message.mp3'],
            volume: 0.7,
            onplayerror: (id, err) => {
                console.warn('Chat sound blocked:', err);
            },
        });
      window.prepareOpenModalChat = this.prepareOpenModalChat;
      window.handleCountMarkReadAll = this.handleCountMarkReadAll;
      this.openRequestedChat();
    },
    beforeUnmount() {
        if (this.socket) {
            this.socket.off();
            this.socket.disconnect();
            this.socket = null;
        }
        if (window.prepareOpenModalChat === this.prepareOpenModalChat) {
            delete window.prepareOpenModalChat;
        }
        if (window.handleCountMarkReadAll === this.handleCountMarkReadAll) {
          delete window.handleCountMarkReadAll;
      }
    },
    methods: {
        muteUsersFun(bool) {
            this.isMuteChat = bool;
        },
        initSocket() {
            const lang = this.language;
            const userId = this.user.id;
            const socketLink = this.chat.chat_ws_host;
            const hash = this.chat.hash;
            const app = this.chat.app;

            this.socket = io(socketLink, {
                reconnectionDelay: 10000,
                agent: false,
                upgrade: false,
                rejectUnauthorized: false,
                reconnection: true,
                reconnectionAttempts: 5,
                transports: ["websocket"],
                query: {
                    'app': app,
                    'user_id': userId,
                    'hash': hash
                }
            });

            this.socket.on("error", (err) => {
                console.warn('Chat socket error:', err);
            });

            this.socket.on("connect_error", (err) => {
                console.warn('Chat socket connect_error:', err);
            });

            this.socket.on("addMessage", (socketData) => {
                this.handleNewMessage(socketData);
            });

            this.socket.on("updateMessage", (socketData) => {
                if (typeof window.handleIncomingMessage === 'function') {
                    window.handleIncomingMessage(socketData, true);
                }
            });

            this.socket.on("addReaction", (socketData) => {
                this.handleReactionsMessage(socketData, true);
            });

            this.socket.on("removeReaction", (socketData) => {
                this.handleReactionsMessage(socketData, false);
            });

            this.socket.on("unreadConversation", (data) => {
                if(this.count !== data.count ) {
                    this.$emit('count-chat', data.count);
                    this.count = data.count;
                    if (typeof window.handleCountMessage === 'function') {
                        window.handleCountMessage(data);
                    }
                }
            });
        },
        handleReactionsMessage(socketData, ifAdd) {
            if (typeof window.handleReactionsMessage === 'function') {
                window.handleReactionsMessage(socketData, ifAdd);
            }
        },
        async handleNewMessage(socketData) {
            if (typeof window.handleIncomingMessage === 'function') {
                window.handleIncomingMessage(socketData);
            }

            if (
                !this.isMiniChatActive &&
                this.isEnableChatSound &&
                !this.isMuteChat &&
                socketData?.message?.user_id !== this.userMy.id 
            ) {
                const conversationUuid = socketData?.conversation?.uuid;
                if (!conversationUuid) return;

                await this.checkConversationMute(conversationUuid);
            }
        },
        async checkConversationMute(conversationUuid) {
            try {
                const { data } = await axios.post(
                '/chat-api/conversation-is-mute',
                { conversation_uuid: conversationUuid },
                {
                    headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                    }
                }
                );

                if (data.status === 'success') {
                const isNotMuted = !data.data.is_mute;

                if (isNotMuted) {
                    try {
                        if (this.chatSound) {
                            this.chatSound.stop();
                            const playPromise = this.chatSound.play();

                            if (playPromise && typeof playPromise.catch === 'function') {
                                playPromise.catch((err) => {
                                    console.warn('Sound blocked (mute check):', err);
                                });
                            }
                        }
                    } catch (e) {
                    console.warn('Sound init error:', e);
                    }
                }

                return data.data.is_mute;
                }

            } catch (e) {
                console.error('Mute check error', e);
                return true;
            }
        },
        // A page can ask to open a chat on load with <div class="js-open-chat" data-user-id="...">.
        openRequestedChat() {
            const el = document.querySelector('.js-open-chat[data-user-id]');
            if (el) {
                this.prepareOpenModalChat(el.dataset.userId);
            }
        },
        handleCountMarkReadAll() {
            this.$emit('count-chat', 0);
            this.count = 0;
        },
        async prepareOpenModalChat(id, newPage = false) {
            if(this.isResponseDone) return;
            this.isResponseDone = true;
            let userId = parseInt(id, 10);
            if(this.userMy.id === userId) {
                this.isResponseDone = false;
                return
            };
            if(!newPage) {
                //this.toggleMiniChat(true);
                this.isActiveConversiation = true;
            }
            if(!this.mobile && !newPage) {
                this.$emit('active-chat');
            }
            
            try {
                const response = await axios({
                    method: 'post',
                    url: '/chat-api/add-conversation',
                    data: { user_id: userId }
                });

                if (response.data) {
                    if(this.mobile || newPage) {
                        window.location.href = '/chats?uuid=' + response.data.data
                    } else if (typeof window.handleAddConversation === 'function') {
                        window.handleAddConversation([response.data.data, userId, !this.countConversiation]);
                    }
                }
            } catch (error) {
                console.error("Error opening modal chat:", error);
            } finally {
                this.isResponseDone = false;
            }
        },
        async getConversationsCount() {
            try {
                const response = await chatFetch(`${this.testUrlQuickChat}conversations/all`, {
                    method: 'GET',
                });
                const result = await response.json();

                if (result?.data) {
                    this.countConversiation = result.data.length;
                    this.usersListAll = result.data;
                    if (this.countConversiation !== 0) {
                        this.$emit('enabled-chat');
                    }
                }
            } catch (e) {
                console.error('Request error:', e);
            }
        }
    }
  };
  </script>

<style lang="scss">

</style>
  